import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { getText } from 'function/language';
import useLoginState from 'global/loginState';
import getRoute from 'routes/routes';
import { RETURN_YN } from 'types/type';

/**
 * 라우터 정보
 */
function useRoute() {
  /* router */
  const { pathname } = useLocation();

  /* recoil */
  const {
    login: { adminYn, haccpYn, pltCd }
  } = useLoginState();

  /* state */
  // 내비
  const [navi, setNavi] = useState('');
  // 라우터 정보
  const [route, setRoute] = useState({
    labelDisable: true,
    children: []
  });

  /* watch */
  useEffect(() => {
    if (adminYn === RETURN_YN.Y || haccpYn !== RETURN_YN.Y || pltCd) {
      setRoute(getRoute());
    }
  }, [adminYn, haccpYn, pltCd, pathname]);
  useEffect(() => {
    const { name, children = [] } =
      route.children.find(({ children = [] } = {}) =>
        children.some(({ to, exact } = {}) =>
          exact ? to === pathname : pathname.includes(to)
        )
      ) ?? {};
    const { name: childrenName, to } =
      children.find(({ to, exact } = {}) =>
        exact ? to === pathname : pathname.includes(to)
      ) ?? {};

    setNavi(
      <>
        {getText(name)}
        {name && childrenName && ' > '}
        {childrenName &&
          (to !== pathname ? (
            <Link to={to}>{getText(childrenName)}</Link>
          ) : (
            getText(childrenName)
          ))}
      </>
    );
  }, [route]);

  return {
    navi,
    route
  };
}

export default useRoute;
